module.exports = __webpack_public_path__ + "static/img/the-hub_256.85d9d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/the-hub_256.png
// module id = Ear1
// module chunks = 0